import axios from 'axios'
// axios.defaults.withCredentials = true
import config from '@/config'

export default {
    data: () => {
        return {
            routes: {
                login: 'https://api.sultantaxi.kz/?a=login',
                register: 'https://api.sultantaxi.kz/?a=register',

                my_transporter_offers: 'https://api.sultantaxi.kz/?a=my_transporter_offers',
                transporter_offers_active: 'https://api.sultantaxi.kz/?a=transporter_offers_active&departure_city={$0}&destination_city={$1}',
                transporter_offers_store: 'https://api.sultantaxi.kz/?a=transporter_offers_store',
                transporter_offers_diactivate: 'https://api.sultantaxi.kz/?a=transporter_offers_diactivate',
                transporter_offers_reactivate: 'https://api.sultantaxi.kz/?a=transporter_offers_reactivate',
                
                my_passenger_offers: 'https://api.sultantaxi.kz/?a=my_passenger_offers',
                passenger_offers_active: 'https://api.sultantaxi.kz/?a=passenger_offers_active&departure_city={$0}&destination_city={$1}',
                passenger_offers_store: 'https://api.sultantaxi.kz/?a=passenger_offers_store',
                passenger_offers_diactivate: 'https://api.sultantaxi.kz/?a=passenger_offers_diactivate',
                passenger_offers_reactivate: 'https://api.sultantaxi.kz/?a=passenger_offers_reactivate',

                account_update: 'https://api.sultantaxi.kz/?a=account_update',
                cities: 'https://api.sultantaxi.kz/?a=cities',
                
                reports_create: 'https://api.sultantaxi.kz/?a=reports_create',

            }
        }
    },
    methods: {
        has_token: () => {
            if (localStorage.getItem(config.token_name) === null) return false    
            return localStorage.getItem(config.token_name)
        },
        api_route: function (routeName, params = null) {
            let routeStr = this.routes[routeName]
            if (params) {
                params.forEach((value, index) => {
                    routeStr = routeStr.replace('{$' + index.toString() + '}', value)
                })
            }
            return routeStr
        },
        getServerData: function (routeName, params = null) {
            const baseUrl = this.api_route(routeName, params)
            if (!this.has_token()) return
            return axios.get(baseUrl, {
                                headers: {
                                    Authorization: 'Bearer ' + this.has_token()
                                }
                            })
        },
        postServerData: function (routeName, { params = null, data }) {
            const baseUrl = this.api_route(routeName, params)
            if (!this.has_token()) return
            return axios.post(baseUrl, data, {
                                headers: {
                                    Authorization: 'Bearer ' + this.has_token()
                                }
                            })
        }
    }
}
